import { PostHogProvider as Provider, usePostHog } from "posthog-js/react";
import type { PropsWithChildren } from "react";

const PostHogProvider = ({ apiKey, children }: PropsWithChildren<{ apiKey: string }>) => {
  return (
    <Provider
      apiKey={apiKey}
      options={{
        debug: __DEV__,
        request_batching: true,
        api_host: "https://eu.posthog.com",
        autocapture: true,
      }}
    >
      {children}
    </Provider>
  );
};

export { usePostHog, PostHogProvider };
export * from "./types";
